module.exports = __webpack_public_path__ + "static/scale-model-of-segs-in-the-city-in-washington-d.c.-45f5e9c650bcbf005a7558936d635b79.png";